import { urlEnum } from "./urlEnum";

let activeRequestCount = 0;

function setLoadingElementVisible(isVisible: boolean): void {
  const element = document.getElementById("loading");
  if (isVisible) {
    element?.classList.remove("loadingDisabled");
    element?.classList.add("loading");
  } else {
    element?.classList.remove("loading");
    element?.classList.add("loadingDisabled");
  }
}

function isLoadingSuppressedForUrl(url?: string): boolean {
  const suppressedLoadingUrlFragments = [
    urlEnum.cacheData,
    urlEnum.scanVehiclePhoto,
    urlEnum.scanVehicleBrief,
    urlEnum.changeBackground,
  ];
  return !!url && suppressedLoadingUrlFragments.some((fragment) => url.includes(fragment));
}

export function beginTrackedRequest(url?: string): void {
  activeRequestCount++;
  if (isLoadingSuppressedForUrl(url)) {
    document.getElementById("loading")?.classList.add("loadingDisabled");
  } else {
    setLoadingElementVisible(true);
  }
}

export function endTrackedRequest(): void {
  activeRequestCount = Math.max(0, activeRequestCount - 1);
  if (activeRequestCount === 0) {
    setLoadingElementVisible(false);
  }
}
